<template>
  <header class="header" :class="{'header--active': isActive }">
    <b-container class="container--wide">
      <b-row>
        <b-col class="d-flex align-items-start align-items-lg-center justify-content-between">
          <router-link :to="{ name:'home' }">
            <img src="@/assets/Logo_Agora.png" class="header__logo" alt="">
          </router-link>
          <b-navbar toggleable="xl" type="dark">
            <b-navbar-toggle target="nav_collapse">
            </b-navbar-toggle>
            <b-collapse is-nav id="nav_collapse"
              @hide="isActive = false" @show="isActive = true">
              <b-navbar-nav :class="{ 'dropdown-shown': dropdownShown}" v-if="!!categoriesList[0]">
                <b-nav-item :to="{ name: 'home' }" v-scroll-to="'#scrollToOnLoad'">
                  {{ $t("nav.home") }}
                </b-nav-item>
                <b-nav-item-dropdown id="nav7_ddown"
                  :text="$t('nav.whatINeedToKnow')">
                  <b-dropdown-item
                    v-for="article in sortedArticles"
                    :key="article.id"
                    :to="{ path: `/need_to_know/${article.id}`}"
                    v-scroll-to="'#scrollToOnLoad'">
                    {{ article.title }}</b-dropdown-item>
                </b-nav-item-dropdown>
                <b-nav-item-dropdown id="nav7_ddown" text="Experiment">
                  <b-dropdown-item :to="{ name: 'login' }" v-scroll-to="'#scrollToOnLoad'"
                    v-if="!isUserLoggedIn">
                    {{ $t("nav.logIn") }}</b-dropdown-item>
                  <b-dropdown-item :to="{ name: 'prev_results' }" v-scroll-to="'#scrollToOnLoad'"
                    v-if="isUserLoggedIn">
                    {{ $t("nav.previouseResults") }}</b-dropdown-item>
                  <b-dropdown-item :to="{ name: 'building_blocks' }" v-scroll-to="'#scrollToOnLoad'"
                    v-if="isUserLoggedIn">
                    {{ $t("nav.chooseMyBuldingBlocks") }}</b-dropdown-item>
                  <b-dropdown-item :to="{ name: 'report_my_results' }"
                    v-scroll-to="'#scrollToOnLoad'"
                    v-if="isUserLoggedIn">
                    {{ $t("nav.reportResults") }}</b-dropdown-item>
                  <b-dropdown-item :to="{ name: 'students_list' }"
                    v-scroll-to="'#scrollToOnLoad'"
                    v-if="isUserLoggedIn && userRole === 'teacher'">
                    {{ $t("nav.studentsList") }}</b-dropdown-item>
                  <b-dropdown-item :to="{ name: 'support' }" v-scroll-to="'#scrollToOnLoad'">
                    {{ $t("nav.technicalSupport") }}</b-dropdown-item>
                </b-nav-item-dropdown>
                <b-nav-item-dropdown id="nav7_ddown" :text="$t('nav.iLoveScience')">
                  <b-dropdown-item :to="{ name: 'science_in_school' }"
                    v-scroll-to="'#scrollToOnLoad'">
                      {{ $t("nav.scienceInSchool") }}</b-dropdown-item>
                  <b-dropdown-item :to="{ name: 'careers' }" v-scroll-to="'#scrollToOnLoad' ">
                    {{ $t("nav.careersInScience") }}</b-dropdown-item>
                  <b-dropdown-item :to="{ name: 'ask_a_scientist' }"
                    v-scroll-to="'#scrollToOnLoad'">
                    {{ $t("nav.askAScientist") }}</b-dropdown-item>
                  <b-dropdown-item :to="{ name: 'learn_more' }" v-scroll-to="'#scrollToOnLoad'">
                    {{ $t("nav.whereCanILearnMore") }}</b-dropdown-item>
                    <b-dropdown-item
                    v-if="!!categoriesList[1]"
                    v-for="article in categoriesList[1].articles"
                    :key="article.id"
                    :to="{ path: `/i_love_science/${article.id}`}"
                    v-scroll-to="'#scrollToOnLoad'">
                  {{ article.title }}</b-dropdown-item>
                </b-nav-item-dropdown>
                <b-nav-item :to="{ name: 'news' }" v-scroll-to="'#scrollToOnLoad'">
                  {{ $t("nav.news") }}</b-nav-item>
                <b-nav-item :to="{ name: 'contact_us' }" v-scroll-to="'#scrollToOnLoad'">
                  {{ $t("nav.contactUs") }}
                </b-nav-item>
                <b-nav-item-dropdown
                    id="nav7_ddown"
                    class="dropdown--last"
                    :text="$t('nav.myAccount')">
                  <b-dropdown-item :to="{ name: 'user_profile' }" v-scroll-to="'#scrollToOnLoad'"
                    v-if="isUserLoggedIn">
                    {{ $t("nav.userProfile") }}</b-dropdown-item>

                  <b-dropdown-item :to="{ name: 'account_details' }" v-scroll-to="'#scrollToOnLoad'"
                    v-if="isUserLoggedIn">{{ $t("nav.accountDetails") }}</b-dropdown-item>

                  <b-dropdown-item @click="logout" v-if="isUserLoggedIn">
                    {{ $t("nav.logOut") }}</b-dropdown-item>

                  <b-dropdown-item :to="{ name: 'login' }" v-scroll-to="'#scrollToOnLoad'" v-else>
                    {{ $t("nav.logIn") }}</b-dropdown-item>

                </b-nav-item-dropdown>
                <b-nav-item class="nav__ico-search">
                  <button class="search__close" v-if="searchActive" @click="searchActive = false">
                    <i class="far fa-times-circle fa-lg"></i>
                  </button>
                  <button @click="search" @keyup.enter="search" class="search__icon"
                    :class="{ 'search__icon--active': searchActive}">
                    <img src="../assets/ico-search.svg" alt="">
                  </button>
                </b-nav-item>
                <b-nav-item-dropdown class="nav__language" id="nav7_ddown" :text="locale">
                  <b-dropdown-item  @click="changeLocale('de')">DE</b-dropdown-item>
                  <b-dropdown-item  @click="changeLocale('en')">EN</b-dropdown-item>
                </b-nav-item-dropdown>
              </b-navbar-nav>
            </b-collapse>
          </b-navbar>
          <input type="text" placeholder="Search" class="search" v-model="searchQuery"
            @keyup.enter="search"
            :class="{ 'search--active': searchActive}">
        </b-col>
      </b-row>
    </b-container>
  </header>
</template>

<script>
import auth from '@/api/v1/auth';
import categories from '@/api/v1/categories';

export default {
  data() {
    return {
      locale: localStorage.getItem('lang'),
      searchActive: false,
      searchQuery: '',
      isActive: false,
      dropdownShown: false,
      isUserLoggedIn: auth.user.authenticated,
      userRole: auth.user.user_type,
      categoriesList: [],
    };
  },
  computed: {
    sortedArticles() {
      return this.categoriesList[0].articles.concat().sort((a, b) => a.position - b.position);
    },
  },
  methods: {
    search() {
      if (this.searchActive) {
        const query = this.searchQuery.trim();
        if (query) {
          this.$router.push({ name: 'search', query: { search: query } });
          this.searchActive = false;
          this.searchQuery = '';
        }
      } else {
        this.searchActive = !this.searchActive;
      }
    },
    logout() {
      auth.logOut();
    },
    getCategories() {
      const succ = (response) => {
        this.categoriesList = response.data.categories;
      };
      categories.index(succ);
    },
    changeLocale(val) {
      localStorage.setItem('lang', val);
      this.$i18n.locale = val;
      location.reload();
    },
  },
  watch: {
    isActive() {
      document.body.style.overflow = this.isActive ? 'hidden' : '';
    },
  },
  created() {
    this.getCategories();
    this.$root.$on('bv::dropdown::hidden', () => {
      this.dropdownShown = false;
    });
    this.$root.$on('bv::dropdown::shown', () => {
      setTimeout(() => {
        this.dropdownShown = true;
      }, 1);
    });
  },
};
</script>

<style lang="scss" scoped>
@import "../styles/helpers/_variables.scss";
@import "../styles/helpers/_include-media.scss";

.header {
  position: absolute;
  top: 15px;
  left: 0;
  background-color: transparent;
  width: 100%;
  @include media("<xl") {
    top: 0;
    z-index: 9;
    padding-top: 40px;
    padding-bottom: 20px;
    background-color: transparent;
  }
  @include media("<md") {
    padding-top: 25px;
  }
  &.header--active {
    @include media("<xl") {
      position: fixed;
    }
    .navbar-collapse{
      height: 100%;
      overflow: scroll;
    }
    .navbar-toggler{
      @include media("<md") {
        position: relative;
      }
    }
    .navbar-nav {
      padding-top: 40px;
    }
  }
  &__logo {
    width: 170px;
    height: 110px;
    @include media('<sm') {
      width: 120px;
      height: 80px;
    }
  }
}
.nav {
  &__ico-search {
    margin-left: 22px;
    position: relative;
    @include media("<xl") {
      display: none;
    }
    .nav-link {
      padding: 0;
    }
    &:before {
      content: "";
      border-left: 2px solid $color--white;
      height: 20px;
      position: absolute;
      top: 2px;
      left: -13px;
    }
  }
  &__language {
    text-transform: uppercase;
    @include media("<xl") {
      display: none;
    }
  }
}

::-webkit-input-placeholder {
  /* Chrome/Opera/Safari */
  color: $color--white;
}
::-moz-placeholder {
  /* Firefox 19+ */
  color: $color--white;
}
:-ms-input-placeholder {
  /* IE 10+ */
  color: $color--white;
}
:-moz-placeholder {
  /* Firefox 18- */
  color: $color--white;
}

.search {
  position: absolute;
  outline: none;
  padding: 2px 30px 2px 15px;
  border-radius: 15px;
  background-color: transparent;
  width: 300px;
  right: 130px;
  top: -62px;
  border: 2px solid $color--white;
  color: $color--white;
  opacity: 0;
  transform: translateY(0px);
  transition: all 0.3s ease;
  @include media("<xl") {
    display: none;
  }

  &--active {
    opacity: 1;
    transform: translateY(54px);
  }
  &__icon {
    transition: transform 0.3s ease;
    filter: drop-shadow(0 0px 4px black);
    &--active {
      transform: translate(-55px, -46px);
    }
  }
  &__close {
    position: absolute;
    color: $color--white;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Header.vue